import React, { useEffect, useState } from "react";
import '../main.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { fetchImagesByPath } from "../features/photos.jsx";
import { TEAM_MEMBERS } from "../teamMembers.js";


function Team() {
  const [imageUrlsByMemberId, setImageUrlsByMemberId] = useState({});

  useEffect(() => {
    let isMounted = true;

    async function loadTeamImages() {
      const results = await Promise.all(
        TEAM_MEMBERS.map(async (member) => {
          try {
            const images = await fetchImagesByPath(member.documentPath);
            return [member.id, images[0] || null];
          } catch (error) {
            console.error(`Error fetching team photo for ${member.name}:`, error);
            return [member.id, null];
          }
        })
      );

      if (isMounted) {
        setImageUrlsByMemberId(Object.fromEntries(results));
      }
    }

    loadTeamImages();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
      <section className="page-section bg-light" id="team">
        <div className="container">
          <div className="text-center">
            <h2 className="section-heading text-uppercase">Our Team</h2>
          </div>

          <div className="row justify-content-center g-4">
            {TEAM_MEMBERS.map((member) => (
              <div className="col-sm-6 col-lg-4" key={member.name}>
                <div className="team-member">
                  {imageUrlsByMemberId[member.id] ? (
                    <img
                      className="mx-auto rounded-circle"
                      src={imageUrlsByMemberId[member.id]}
                      alt={member.name}
                    />
                  ) : (
                    <div className="team-member__image-placeholder" aria-hidden="true"></div>
                  )}
                  <h4>{member.name}</h4>
                  <p className="text-muted">{member.role}</p>
                  <a
                    className="btn btn-dark btn-social mx-2"
                    href={`tel:${member.phone}`}
                    aria-label={`Call ${member.name}`}
                  >
                    <FontAwesomeIcon icon={faPhone} />
                  </a>
                </div>
              </div>
            ))}
          </div>
          <div className="row">
            <div className="col-lg-8 mx-auto text-center">
              <p className="large text-muted">
                For inquiries regarding rental properties please fill out the form below.
              </p>
            </div>
          </div>
        </div>
      </section>
  );
}

export default Team;
